import React from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import AccountForm from 'components/adm/account/accountForm';
import Message from 'components/parts/message';
import { getAccount, updateAccount } from 'actions/accountAction';
import { setBreadcrumb } from 'actions/breadcrumbAction';
import { clearMessage, setMessage } from 'actions/messageAction';
import { consoleLogger } from 'helpers';
import { lang } from 'lang';

/**
 * 管理者アカウント編集画面
 */
const AdmAccountEdit = (props) => {
  const dispatch = useDispatch();
  const { id } = props.match.params;
  const { msg, error, validate } = lang;
  // リクエストキャンセルトークンを取得
  const cancelToken = axios.CancelToken.source();
  // グローバルステートから対象の管理者アカウントを取り出す
  const accountState = useSelector(
    (state) => state.account.items.filter((item) => item.sub === id)
  );
  const { register, handleSubmit, formState, errors } = useForm({ mode: 'onChange' });

  React.useEffect(() => {
    // 管理者アカウント情報がステートにない場合
    if (accountState.length === 0) {
      getData(id, cancelToken);
    } else {
      dispatch(clearMessage());
      dispatch(setBreadcrumb(accountState[0].name, accountState[0].sub));
    }
    return () => {
      // unmounted component時にコールされる
      cancelToken.cancel('unmounted component.');
    };
  }, []);

  // 指定したid(=sub)と一致する管理者アカウント情報を取得する
  const getData = async (id, cancelToken) => {
    try {
      await dispatch(
        await getAccount(id, cancelToken)
      ).then((result) => {
        if (result.status === 200) {
          dispatch(setBreadcrumb(result.data.name, result.data.sub));
        } else if (result.status === 404) {
          dispatch(setMessage('info', msg.account.not_exist));
        } else {
          dispatch(setMessage('danger', error.account.get + `\n${result.errcode}`));
        }
      });
    } catch (e) {
      consoleLogger('Fail get account detail.', e);
    }
  };

  // 管理者アカウント情報がステートにない場合
  if (accountState.length === 0) {
    return <div className="col-10 pt-3 pb-3"><Message/></div>;
  } else {
    // 更新ボタンが押されたときに実行される
    const onSubmit = async params => {
      // メッセージクリア
      dispatch(clearMessage());
      await dispatch(
        await updateAccount(accountState[0].sub, params)
      ).then((result) => {
        // Success
        if (result.status === 200) {
          props.history.replace({
            pathname: '/adm/accounts',
            state: { 
              keepMessage: true,  // 一覧画面表示時にメッセージを残す
              message: {
                type: 'success',
                msg: msg.account.update,
              }
            }
          });
        // Warning
        } else if (result.status === 400 && result.errcode === 'INVALID_PARAMETER_PHONE_NUMBER') {
          dispatch(setMessage('warning', validate.invalid_phone_number));
        // Not found
        } else if (result.status === 404) {
          dispatch(setMessage('danger', msg.account.not_exist));
        // Error
        } else {
          dispatch(setMessage('danger', error.account.update + `\n${result.errcode}`));
        }
      });
    };

    return (
      <>
        <div className="col-10 pt-3 pb-3">
          <Message/>
          <AccountForm 
            isUpdate={true} 
            values={accountState[0]}
            onSubmit={handleSubmit(onSubmit)}
            register={register}
            formState={formState}
            errors={errors}
          />
        </div>
      </>
    );
  }
};
AdmAccountEdit.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object
};
AdmAccountEdit.defaultProps = {
  match: {
    params: {
      id: '',
    }
  }
};
export default AdmAccountEdit;
